import { buildProps } from '@code-monkey-ui/utils'

import { useSizeProp } from '@code-monkey-ui/hooks'
import type { ExtractPropTypes } from 'vue'
import type Batch from './batch.vue'

export const batchProps = buildProps({
  /**
   * @description 多选选项
   */
  options: {
    type: Array as () => any[],
    default: () => [],
  },
  /**
   * @description 组件宽度
   */
  width: {
    type: [String, Number],
    default: 400,
  },
  /**
   * @description 组件尺寸
   */
  size: useSizeProp,
  /**
   * @description 是否禁用组件
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 弹窗textarea的自适应最小行数
   */
  minRows: {
    type: Number,
    default: 8,
  },
  /**
   *  @description 弹窗textarea的自适应最大行数，超过则出现滚动条
   */
  maxRows: {
    type: Number,
    default: 12,
  },
  /**
   * @description 空文本提示
   */
  emptyText: {
    type: String,
    default: '暂无数据',
  },
  /**
   * @description 自定义option的label和value
   */
  labelValue: {
    type: Object as () => { label: string; value: string },
    default: () => ({ label: 'label', value: 'value' }),
  },
  /**
   * @description 多行输入框的行数
   */
  rows: {
    type: Number,
    default: 50,
  },
  /**
   * @description 是否需要tag
   */
  needTag: {
    type: Boolean,
    default: false,
  },
} as const)

export const batchEmits = {
  optionsChange: (val: any) => val,
  multipleSearch: (val: object) => val,
  search: (val: object) => val,
  clearMultipleValue: () => true,
  'update:fullData': (val: any) => val,
}

export type BatchProps = ExtractPropTypes<typeof batchProps>
export type BatchInstance = InstanceType<typeof Batch>
export type BatchEmits = typeof batchEmits
